import React, { useEffect, useState } from 'react';

import { Card, CardContent, Grid, makeStyles, Typography } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import CategoryChipContainer from './CategoryChipContainer';
import ReorderPopup from './ReorderPopup';
import { CustomMenu } from '../../shared/CustomMenu';
import { categoryMenuList } from '../constants';
import AddCategoryPopup from './AddCategoryPopup';
import DeleteIcon from '../../../assets/DeleteIcon';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { showProgress } from '../../../redux/actions/DealershipActions';
import ConfirmationDialog from '../../common/ConfirmationDialog';
import useCategory from '../hooks/useCategory';
import { ErrorToast, notifySuccess } from '../../utils/Utils';

const useStyles = makeStyles({
  categoryCardContainer: {
    height: '44px',
  },
  categoryMainCard: {
    height: '44px',
    borderRadius: '0px 8px 8px 8px',
    border: '1px 0px 0px 0px',
    justify: 'space-between',
    marginBottom: '16px',
    background: 'rgb(244, 244, 244)',
  },
  categoryMainText: {
    fontFamily: 'Lato',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '19.6px',
    textAlign: 'left',
    color: '#10182B',
  },
  moreIcon: {
    height: '20px',
    cursor: 'pointer',
  },
});

const CategoryCard = ({ categoryId, categoryName, title, ind, deptId, value, deptName, collections }) => {
  const dispatch = useDispatch();
  const selectedId = useSelector((state) => state.categoryData.selectedId);
  const { fetchPartnerTypes } = useCategory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openReorder, setOpenReorder] = useState(false);
  const [openEditCategory, setOpenEditCategory] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [menuList, setMenuList] = useState(categoryMenuList);
  const [reorderType, setReorderType] = useState('');
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleReorderClose = () => setOpenReorder(false);
  const handleCategoryClose = () => setOpenEditCategory(false);
  const handleDeleteConfirmClose = () => setOpenDeleteConfirm(false);
  const handleMenuItemClick = ({ target: { id } }, name) => {
    console.log(id, name);
    if (name === 'Reorder Collections' || name === 'Reorder Categories') {
      setReorderType(name);
      setOpenReorder(true);
    } else if (name === 'Edit Category') {
      setOpenEditCategory(true);
    } else if (name === 'Delete Category') {
      setOpenDeleteConfirm(true);
    }
  };
  useEffect(() => {
    if (collections?.length <= 1) {
      setMenuList((prevList) => prevList.filter((item) => item?.name !== 'Reorder Collections'));
    }
  }, [collections?.length]);
  const handleDelete = async () => {
    dispatch(showProgress(true));
    await service
      .delete(apiEndpoints.CAT_CATEGORY_DELETE.replace('CAT_ID', categoryId))
      .then(() => {
        handleDeleteConfirmClose();
        dispatch(showProgress(false));
        notifySuccess('Category Successfully Deleted');
        fetchPartnerTypes(selectedId);
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
        setOpenDeleteConfirm(false);
      });
  };
  const classes = useStyles();

  return (
    <Grid container direction="column">
      <Grid item>
        <CategoryChipContainer ind={ind} categoryId={categoryId} deptName={deptName} deptId={deptId} />
      </Grid>
      <Grid item>
        <Card className={classes.categoryMainCard}>
          <CardContent>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
              <Grid item>
                <Typography component="div" className={classes.categoryMainText}>
                  {title}
                </Typography>
              </Grid>
              <Grid item>
                <MoreVert className={classes.moreIcon} onClick={handleClick} />
                <CustomMenu
                  id={1}
                  handleClose={handleClose}
                  anchorEl={anchorEl}
                  menuItems={menuList}
                  handleMenuItemClick={handleMenuItemClick}
                />
                <ReorderPopup
                  isOpen={openReorder}
                  handleClose={handleReorderClose}
                  categoryId={categoryId}
                  reorderType={reorderType}
                  deptId={deptId}
                />
                <AddCategoryPopup
                  isOpen={openEditCategory}
                  isEdit
                  categoryId={categoryId}
                  departmentId={deptId}
                  categoryName={categoryName}
                  handleClose={handleCategoryClose}
                  tabValue={value}
                />
                <ConfirmationDialog
                  title="Are you sure you want to delete this category?"
                  subText="Once done you cannot undo this action."
                  onClose={handleDeleteConfirmClose}
                  isOpen={openDeleteConfirm}
                  confirmFn={handleDelete}
                  disagreeText="Cancel"
                  agreeText="Delete"
                  Icon={DeleteIcon}
                  width="335px"
                  height="229px"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CategoryCard;
